import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { PipeModule } from 'src/app/pipes/pipe-module.module';
import { OpenCarruselGalleriesComponentTwo } from './open-carrusel-galleries/open-carrusel-galleries-two.component';

const declarations = [OpenCarruselGalleriesComponentTwo];

@NgModule({
  declarations,
  imports: [CommonModule, IonicModule, PipeModule],
  exports: declarations,
})
export class ComponentsSliderTwoModule {}
